import { useState } from "react";
import PropTypes from "prop-types";
import Modal from "@shared/v2/Modal";
import { UploadSolidV6 } from "@shared/v2/Icomoon";
import BaseEvent from "./BaseEvent";

const TimelineDocumentEvent = ({ event }) => {
  const [showModal, setShowModal] = useState(false);
  const { event_type: eventType, timeline_fields: timelineFields, interacted_at_absolute: interactedAtAbsolute } = event;
  const { updater_name: updaterName, uploader_name: uploaderName, document_name: documentName, document_url: documentUrl } = timelineFields;

  const isDestroyed = eventType === "document_destroyed";
  const actorName = isDestroyed ? (updaterName || uploaderName) : uploaderName;
  const action = isDestroyed ? "deleted" : "uploaded";

  const title = (
    <div>
      <span className="tw-font-semibold">{actorName}</span>
      {` ${action} a document`}
    </div>
  );

  const content = (
    <>
      <div className="tw-font-semibold">Details:</div>
      <div>
        Document Name:{" "}
        <a href={documentUrl} target="_blank" rel="noopener noreferrer">
          {documentName}
        </a>
      </div>
    </>
  );

  return (
    <BaseEvent
      icon={<UploadSolidV6 />}
      title={title}
      interactedAt={interactedAtAbsolute}
      onClick={() => setShowModal(true)}
    >
      {content}
      <Modal
        dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
        contentClassName="tw-max-w-[480px] tw-w-full tw-max-h-[90vh] tw-flex tw-flex-col tw-gap-[32px]"
        show={showModal}
        onHide={() => setShowModal(false)}
      >
        <Modal.Header title="Document" closeButton />
        <Modal.Body>
          {title}
          {content}
        </Modal.Body>
      </Modal>
    </BaseEvent>
  );
};

TimelineDocumentEvent.propTypes = {
  event: PropTypes.shape().isRequired,
};

export default TimelineDocumentEvent;
